import React from "react";
import Styles from "./MyProfiles.module.scss";
import profileIcon from "../../assets/icons/profile-focus.svg";
import trashIcon from "../../assets/icons/trash.svg";
import arrowRightGreenIcon from "../../assets/icons/arrowRightGreen.svg";
import { useAppDispatch } from "../../redux/store";
import { useSelector } from "react-redux";
import { ModalTexts } from "../../resources/locale";
import { Button, Modal } from "../../components";
import { ProfileAdultForm } from "../ProfileAdultForm";
import { ProfileKidForm } from "../ProfileKidForm";
import { IProfileItem } from "./types";
import {
  fetchDelProfiles,
  fetchMyProfiles,
  fetchEditProfile,
} from "../../redux/profile/profileInfo/asyncActions";
import { getProfileInfoMenu } from "../../redux/profile/profileInfo/selectors";
import { setDeleteProfile } from "../../redux/profile/profileInfo/slice";
import { IMyprofile } from "../../redux/profile/profileInfo/types";
import { ValuesType as AdultValuesType } from "../ProfileAdultForm/type";
import { ValuesType as KidValuesType } from "../ProfileKidForm/type";
import { formatPhone } from "../../utils/form/phoneFormat";
import { useLookUpUsers } from "../../hooks/useLookUpUsers";
import { formatDateToISO } from "../../helpers/dateFormatter";

export const MyProfileItem: React.FC<IProfileItem> = (props) => {
  const { onPage = "profile", selectFunc } = props;
  const [isOpenModal, setIsOpenModal] = React.useState<boolean>(false);
  const [isOpenEditModal, setIsOpenEditModal] = React.useState<boolean>(false);
  const dispatch = useAppDispatch();
  const { getBitrixUser } = useLookUpUsers();

  const { deleteProfile } = useSelector(getProfileInfoMenu);
  const handleCloseModalNoConfirm = () => {
    setIsOpenModal(false);
    dispatch(fetchMyProfiles());
  };

  const handleCloseModalConfirm = async () => {
    const profileId = (deleteProfile as IMyprofile)?.id;
    if (profileId) {
      await dispatch(fetchDelProfiles(profileId));
      setIsOpenModal(false);
      await dispatch(fetchMyProfiles());
    }
  };

  function handleRemove(data: IMyprofile) {
    setIsOpenModal(true);
    dispatch(setDeleteProfile(data));
  }

  const handleSelectProfile = () => {
    if (selectFunc) {
      selectFunc(props.data);
    } 
    else if (onPage === "profile") {
      setIsOpenEditModal(true);
    }
  };

  const formatDateToDDMMYYYY = (dateString: string | null | undefined): string => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    } catch (error) {
      return dateString;
    }
  };

  const handleEditProfileSubmit = async (values: AdultValuesType | KidValuesType) => {
    try {
      const profileId = props.data.id;
      
      if (props.data.type === "adult" || props.data.is_adult) {
        const adultValues = values as AdultValuesType;
        const phone = formatPhone(adultValues.phone || "");
        
        const bitrixUserResult = await getBitrixUser(
          phone,
          null,
          null,
          adultValues.name,
          false
        );

        await dispatch(
          fetchEditProfile({
            profileId,
            name: adultValues.name,
            phone: phone,
            email: adultValues.email || "",
            is_adult: true,
            partner_id: bitrixUserResult || null,
          })
        );
      } 
      else {
        const kidValues = values as KidValuesType;
        const birthDateISO = kidValues.birthday ? formatDateToISO(kidValues.birthday) : "";

        await dispatch(
          fetchEditProfile({
            profileId,
            name: kidValues.name,
            birth_date: birthDateISO,
            is_adult: false,
          })
        );
      }

      setIsOpenEditModal(false);
      await dispatch(fetchMyProfiles());
    } catch (error) {
    }
  };

  return (
    <>
      {(props.data.deleted === undefined || props.data.deleted !== 1) ? (
        <div
          className={Styles.item}
          data-type={props.dataType}
          onClick={handleSelectProfile}
        >
          <div className={Styles.profileInfo}>
            <img className={Styles.img} src={profileIcon} />
            <div>
              <div className={Styles.title}>
                {props.data.is_self === 1 ? "Вы" : (props.data.name || "")}
              </div>
              <div className={Styles.content}>
                <div className={`${Styles.text_phone}`}>
                  {props.data.type === "adult" ? (props.data.phone || "") : (props.data.birthday || props.data.birth_date || "")}
                </div>
              </div>
            </div>
          </div>
          
          {onPage === "profile" && (props.data.is_self === undefined || props.data.is_self === 0) ? (
            <div className={Styles.arrowRightGreenIconContainer}>
              <div className={Styles.arrowRightGreenIcon}>
                <img src={arrowRightGreenIcon} />
              </div>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemove(props.data);
                }}
                className={`${Styles.item_trash}`}
              >
                <img src={trashIcon} />
              </div>
            </div>
            
          ) : null}
        </div>
      ) : null}
      {isOpenModal ? (
        <Modal
          title={ModalTexts.deleteProfile.confirmation.TITLE}
          subTitle={ModalTexts.deleteProfile.confirmation.SUB_TITLE}
          isOpen={isOpenModal}
          setIsOpen={setIsOpenModal}
          closeFunc={handleCloseModalNoConfirm}
        >
          <div className={Styles.buttons}>
            <Button newStyles={Styles.button} onClickFunc={handleCloseModalNoConfirm}>
              Отмена
            </Button>
            <Button onClickFunc={handleCloseModalConfirm}>Удалить</Button>
          </div>
        </Modal>
      ) : null}
      
      {isOpenEditModal ? (
        <Modal
          title="Редактирование профиля"
          isOpen={isOpenEditModal}
          setIsOpen={setIsOpenEditModal}
          closeFunc={() => setIsOpenEditModal(false)}
        >
          {props.data.type === "adult" || props.data.is_adult ? (
            <ProfileAdultForm
              page="profile"
              close={handleEditProfileSubmit}
              profileValues={{
                name: props.data.name || "",
                secondaryText: props.data.phone || "",
                email: props.data.email || undefined,
                type: "adult",
              }}
            />
          ) : (
            <ProfileKidForm
              page="profile"
              close={handleEditProfileSubmit}
              profileValues={{
                name: props.data.name || "",
                secondaryText: formatDateToDDMMYYYY(props.data.birth_date || props.data.birthday),
                type: "kid",
              }}
            />
          )}
        </Modal>
      ) : null}
    </>
  );
};
